import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/shared/api/auth";
import { markManualLogout } from "@/shared/auth/savedLogin";
import { useAuth } from "@/shared/auth/store";
import { useToast } from "@/shared/ui/Toast";

/**
 * 로그아웃 한 곳 — 사이드바의 AccountMenu(데스크톱)와 더보기 시트(모바일)가
 * 같은 훅을 쓴다.
 *
 * 서버 블랙리스트 등록은 **best-effort** 다. /auth/logout 이 실패해도 로컬
 * 세션은 반드시 지운다 — 서버 장애 때문에 사용자가 로그인된 상태에 갇히면
 * 공용 단말에서 다음 사람이 그 세션을 그대로 물려받는다.
 */
export function useLogout() {
  const refresh = useAuth((s) => s.refresh);
  const clear = useAuth((s) => s.clear);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async () => {
      if (refresh) {
        try {
          await authApi.logout(refresh);
        } catch {
          /* swallow — 아래 onSettled 가 어느 쪽이든 로컬 세션을 지운다 */
        }
      }
    },
    onSettled: () => {
      // 저장된 계정이 있어도 이번 실행에서는 자동 로그인하지 않는다 —
      // 아니면 로그아웃하자마자 로그인 화면이 다시 로그인해 버린다.
      markManualLogout();
      clear();
      toast({ title: t("widgets.account.toast.loggedOut"), tone: "info" });
      navigate("/login", { replace: true });
    },
  });
}
